// ═══════════════════════════════════════════════════════════
// EXERCISE → VIDEO LINKS
// Maps a checklist item id (from journalChecklist.js) to a VIP
// Video Library URL. When a match exists, the exercise name in the
// client's plan becomes a clickable "▶ watch" link.
//
// TO ADD A LINK: find the item's id in journalChecklist.js and add
//   'the-item-id': 'https://youtu.be/XXXXXXXX',
// (the URL is the same YouTube link used in the Video Library.)
// ═══════════════════════════════════════════════════════════

export const exerciseVideos = {
  // Feldenkrais
  'fk-leader-follower-inner-thigh': 'https://youtu.be/lN5_pvkuo68', // Hip Development — Leader / Follower Inner Thigh
  'fk-back-reset': 'https://youtu.be/yCVIIdBWptI',                   // Back Reset I
  'fk-shoulder-spine-integrator': 'https://youtu.be/SDu1FQesaXw',    // Shoulder Spine Integrator
  'fk-super-gentle-shoulder-spine-integrator': 'https://youtu.be/LQA6knB3el8', // Super Gentle Shoulder Spine Integrator

  // Fascial Maneuvers (demonstrated in the Stress Reset video)
  'fm-c-totally-twisted': 'https://youtu.be/c-8RuEgU3Fw',
  'fm-c-anti-gravity': 'https://youtu.be/c-8RuEgU3Fw',
  'fm-uj-elbow-torque': 'https://youtu.be/c-8RuEgU3Fw',

  // Back Reset remedies
  'br-remedy-3': 'https://youtu.be/ePjCDq03Zqg',  // Hanna 3 Part Flexion
  'br-remedy-7': 'https://youtu.be/l9mYPJfI_IU',  // Diagonals — Up and Over
  'br-remedy-15': 'https://youtu.be/2Gjz_F02PIA', // The Fish
};
